<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="12" class="text-center text-sm-left flex-header">
                <h3 class="page-title">Generator harmonogramu</h3>
                <d-dropdown
                    text="Pobierz harmonogram"
                    theme="success"
                    class="mr-2"
                >
                    <d-dropdown-item>
                        <div
                            class="loader black-loader"
                            :class="{ isLoading: isLoadingPdf }"
                            @click.prevent="downloadPdf()"
                        >
                            PDF
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item>
                        <div
                            class="loader black-loader"
                            :class="{ isLoading: isLoadingExcel }"
                            @click.prevent="downloadExcel()"
                        >
                            Excel
                        </div>
                    </d-dropdown-item>
                </d-dropdown>
                <d-button theme="primary" @click.prevent="submitDraft"
                    ><i class="material-icons">save</i> Zapisz jako
                    szkic</d-button
                >
                <!--                <d-button  :class="{isLoading : submitting}" theme="success" @click.prevent="submitForm">Generuj harmonogram</d-button>-->
            </d-col>
        </d-row>

        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">
                <div v-if="isValuesSetup" class="overlay-loading">
                    <h2 class="preloader isLoading">Trwa ładowanie</h2>
                </div>

                <!-- Form Example -->
                <d-card-header class="border-bottom">
                    <h6 class="m-0">Formularz nowego harmonogramu</h6>
                </d-card-header>

                <d-list-group flush @keyup.enter="submitForm">
                    <d-list-group-item class="p-3">
                        <div class="card-body p-0 pb-3 text-center mb-3">
                            <table
                                class="table mb-0"
                                style="
                                    border: 1px #dee2e6 solid;
                                    table-layout: fixed;
                                "
                            >
                                <thead class="bg-light">
                                    <tr>
                                        <th scope="col" class="border-0">
                                            Kwota pożyczki (w tym prowizja)
                                        </th>
                                        <th scope="col" class="border-0">
                                            Kwota pożyczki dla klienta
                                        </th>
                                        <th scope="col" class="border-0">
                                            Prowizja
                                        </th>
                                        <th scope="col" class="border-0">
                                            Odsetki
                                        </th>
                                        <th scope="col" class="border-0">
                                            Kwota końcowa
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {{
                                                toNumber(schedule.loan_amount + schedule.installment_sum)
                                            }}
                                            zł
                                        </td>
                                        <td>
                                            {{
                                                toNumber(schedule.loan_amount)
                                            }}
                                            zł
                                        </td>
                                        <td>
                                            {{
                                                toNumber(
                                                    schedule.installment_sum
                                                )
                                            }}
                                            zł
                                        </td>
                                        <td>
                                            {{
                                                toNumber(schedule.interest_sum)
                                            }}
                                            zł
                                        </td>
                                        <td>
                                            {{
                                                toNumber(
                                                    schedule.loan_installment_sum +
                                                        schedule.interest_penalty_sum +
                                                        schedule.interest_sum
                                                )
                                            }}
                                            zł
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <d-row>
                            <d-col md="5">
                                <d-form>
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label>Nazwa załącznika</label>
                                            <ss-input
                                                type="text"
                                                name="schedule_attachment_name"
                                                class="text-left"
                                                v-model="
                                                    schedule.schedule_attachment_name
                                                "
                                                placeholder=""
                                            />
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label class="w-100"
                                                >Uwzględnij VAT</label
                                            >
                                            <d-checkbox
                                                inline
                                                v-model="vatIncluded"
                                                toggle
                                            />
                                        </d-col>
                                    </d-form-row>
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label
                                                >Kolejność zaliczania
                                                wpłat</label
                                            >
                                            <d-select
                                                name="payment_allocation"
                                                v-model="
                                                    schedule.payment_allocation
                                                "
                                            >
                                                <option value="capital_first">
                                                    Najpierw kapitał
                                                </option>
                                                <option value="interest_first">
                                                    Najpierw koszty i odsetki
                                                </option>
                                            </d-select>
                                        </d-col>
                                    </d-form-row>
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label>Kwota pożyczki dla klienta</label>
                                            <ss-price-input
                                                type="text"
                                                name="loan_amount"
                                                v-model="schedule.loan_amount"
                                                @input="
                                                    lar_errors.clear(
                                                        'loan_amount'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'loan_amount'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'loan_amount'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label>Data umowy</label>
                                            <ss-date
                                                type="text"
                                                name="contract_date"
                                                v-model="schedule.contract_date"
                                                @click="
                                                    lar_errors.clear(
                                                        'contract_date'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'contract_date'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'contract_date'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                    </d-form-row>
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label>Odsetki (%)</label>
                                            <ss-price-input
                                                type="text"
                                                name="loan_installment"
                                                @change="calculateCapitals"
                                                v-model="schedule.interest_rate"
                                                @blur="calculateCapitals"
                                                @input="
                                                    lar_errors.clear(
                                                        'interest_rate'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'interest_rate'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'interest_rate'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                        <d-col
                                            v-if="schedule.include_vat === 0"
                                            md="6"
                                            class="form-group"
                                        >
                                            <label>Prowizja (zł)</label>
                                            <ss-price-input
                                                type="text"
                                                name="loan_installment"
                                                @input="calculateCapitals"
                                                v-model="
                                                    schedule.installment_rate
                                                "
                                                @change="
                                                    lar_errors.clear(
                                                        'installment_rate'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'installment_rate'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'installment_rate'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                    </d-form-row>
                                    <d-form-row
                                        v-if="schedule.include_vat === 1"
                                    >
                                        <d-col md="6" class="form-group">
                                            <label>Prowizja netto (zł)</label>
                                            <ss-price-input
                                                v-model="installment_rate_net"
                                                @input="
                                                    setGrossForValue(
                                                        installment_rate_net,
                                                        'schedule.installment_rate',
                                                        'installment_rate',
                                                        'input'
                                                    )
                                                "
                                                :disabled="
                                                    isValuesSetup ||
                                                    isCalculatingGross ||
                                                    isCalculatingNet
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'installment_rate_net'
                                                        ),
                                                }"
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'installment_rate_net'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label>Prowizja brutto (zł)</label>
                                            <ss-price-input
                                                type="text"
                                                name="loan_installment"
                                                v-model="
                                                    schedule.installment_rate
                                                "
                                                :disabled="
                                                    isValuesSetup ||
                                                    isCalculatingGross ||
                                                    isCalculatingNet
                                                "
                                                @input="
                                                    setNetForValue(
                                                        schedule.installment_rate,
                                                        'installment_rate_net',
                                                        'installment_rate_net',
                                                        'input'
                                                    )
                                                "
                                                @change="
                                                    lar_errors.clear(
                                                        'installment_rate'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'installment_rate'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'installment_rate'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                    </d-form-row>
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label for="number_of_installments"
                                                >Liczba rat</label
                                            >
                                            <input
                                                class="form-control"
                                                id="number_of_installments"
                                                type="text"
                                                @blur="rearrangeInstallments"
                                                name="number_of_installments"
                                                v-model="
                                                    schedule.number_of_installments
                                                "
                                                @input="
                                                    lar_errors.clear(
                                                        'number_of_installments'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'number_of_installments'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'number_of_installments'
                                                    )
                                                "
                                            ></div>
                                            <d-button
                                                class="m-top"
                                                @click.prevent="
                                                    optimalInstallmentsNumber
                                                "
                                                >Optymalna liczba rat</d-button
                                            >
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label>Kwota raty</label>
                                            <ss-price-input
                                                type="text"
                                                name="installment_fee"
                                                v-model="
                                                    schedule.installment_fee
                                                "
                                                @change="
                                                    lar_errors.clear(
                                                        'installment_fee'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'installment_fee'
                                                        ),
                                                }"
                                                @input="generateTable"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'installment_fee'
                                                    )
                                                "
                                            ></div>
                                            <d-button
                                                class="m-top"
                                                @click.prevent="
                                                    optimalInstallmentFee
                                                "
                                                >Optymalna kwota raty</d-button
                                            >
                                        </d-col>
                                    </d-form-row>
                                    <d-form-row>
                                        <d-col md="6" class="form-group">
                                            <label>Data pierwszej raty</label>
                                            <ss-date
                                                type="text"
                                                name="first_installment_date"
                                                v-model="
                                                    schedule.first_installment_date
                                                "
                                                @click="
                                                    lar_errors.clear(
                                                        'first_installment_date'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'first_installment_date'
                                                        ),
                                                }"
                                                placeholder=""
                                            />
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'first_installment_date'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                        <d-col md="6" class="form-group">
                                            <label>Częstotliwość rat</label>
                                            <d-select
                                                type="text"
                                                name="installment_frequency"
                                                v-model="
                                                    schedule.installment_frequency
                                                "
                                                @input="
                                                    lar_errors.clear(
                                                        'installment_frequency'
                                                    )
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        lar_errors.has(
                                                            'installment_frequency'
                                                        ),
                                                }"
                                                placeholder=""
                                            >
                                                <option
                                                    :value="period.id"
                                                    v-for="period in installment_frequency_periods"
                                                    :key="period.id"
                                                >
                                                    {{ period.name }}
                                                </option>
                                            </d-select>
                                            <div
                                                class="invalid-feedback"
                                                v-text="
                                                    lar_errors.get(
                                                        'installment_frequency'
                                                    )
                                                "
                                            ></div>
                                        </d-col>
                                    </d-form-row>
                                </d-form>
                                <ss-textarea
                                    v-model="schedule.comments"
                                    name="comments"
                                    label="Komentarze"
                                    placeholder="Opis..."
                                ></ss-textarea>
                            </d-col>
                            <d-col md="7">
                                <div class="card-body p-0 pb-3 text-center">
                                    <table
                                        class="table mb-0"
                                        style="
                                            border: 1px #dee2e6 solid;
                                            table-layout: fixed;
                                        "
                                    >
                                        <thead class="bg-light">
                                            <tr>
                                                <th
                                                    scope="col"
                                                    class="border-0 col-id"
                                                >
                                                    #
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-0"
                                                >
                                                    Data płatności
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-0"
                                                >
                                                    Rata
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-0"
                                                >
                                                    Kapitał
                                                </th>
                                                <th
                                                    scope="col"
                                                    class="border-0"
                                                >
                                                    Odsetki
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                :class="{
                                                    red: rowThemeDanger(
                                                        installment
                                                    ),
                                                }"
                                                v-for="(
                                                    installment, index
                                                ) in schedule.installments"
                                            >
                                                <td>
                                                    {{ parseInt(index) + 1 }}
                                                </td>
                                                <td>
                                                    <ss-date
                                                        type="text"
                                                        name="payment_date"
                                                        v-model="
                                                            installment.payment_date
                                                        "
                                                        @click="
                                                            lar_errors.clear(
                                                                'payment_date'
                                                            )
                                                        "
                                                        :limitfrom="
                                                            getLimitFrom(index)
                                                        "
                                                        :limitto="
                                                            getLimitTo(index)
                                                        "
                                                        :class="{
                                                            'is-invalid':
                                                                lar_errors.has(
                                                                    'payment_date'
                                                                ),
                                                        }"
                                                        placeholder=""
                                                    />
                                                    <div
                                                        class="invalid-feedback"
                                                        v-text="
                                                            lar_errors.get(
                                                                'payment_date'
                                                            )
                                                        "
                                                    ></div>
                                                </td>
                                                <td>
                                                    <ss-price-input
                                                        :readonly="
                                                            index >
                                                            schedule
                                                                .installments
                                                                .length -
                                                                2
                                                        "
                                                        type="text"
                                                        name="installment_fee"
                                                        v-model="
                                                            installment.installment_fee
                                                        "
                                                        @input="
                                                            singleInstallmentChanged
                                                        "
                                                        placeholder=""
                                                    />
                                                </td>
                                                <td>
                                                    {{
                                                        toNumber(
                                                            installment.capital
                                                        )
                                                    }}
                                                    zł
                                                </td>
                                                <td
                                                    :class="{
                                                        'is-loading':
                                                            interests_loading,
                                                    }"
                                                >
                                                    {{
                                                        toNumber(
                                                            installment.interest
                                                        )
                                                    }}zł
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </d-col>
                        </d-row>
                    </d-list-group-item>
                </d-list-group>
                <ss-modal
                    v-show="saveDraftModal"
                    title="Title"
                    intro="bounceIn"
                    outro="bounceOut"
                >
                    <!-- HEADER -->
                    <div slot="modal-header">
                        Wybierz klienta
                        <i class="close" @click="saveDraftModal = false"></i>
                    </div>
                    <!-- BODY -->
                    <div slot="modal-body" class="text-center">
                        <fieldset class="form-group">
                            <label>Wybierz klienta z listy</label>
                            <div
                                class="d-flex"
                                :class="{
                                    'is-invalid': lar_errors.has('client_id'),
                                }"
                            >
                                <v-select
                                    class="w-100"
                                    :options="allClientsShort"
                                    v-model="schedule.client_id"
                                    @input="lar_errors.clear('client_id')"
                                    :reduce="(client) => client.id"
                                    placeholder="Wpisz dane klienta..."
                                    @search="fetchClientsOptions"
                                    label="name"
                                >
                                    <template
                                        slot="selected-option"
                                        slot-scope="option"
                                    >
                                        {{ option.name
                                        }}<span
                                            v-if="option.client_internal"
                                            class="text-primary ml-1"
                                        >
                                            (do umów wewnętrznych)</span
                                        >
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        {{ option.name
                                        }}<span
                                            v-if="option.client_internal"
                                            class="text-primary ml-1"
                                        >
                                            (do umów wewnętrznych)</span
                                        >
                                    </template>
                                    <span slot="no-options">
                                        Brak wyników
                                    </span>
                                </v-select>
                            </div>
                            <div
                                class="invalid-feedback"
                                :class="{
                                    'd-block': lar_errors.get('bailiff_id'),
                                }"
                                v-text="lar_errors.get('bailiff_id')"
                            ></div>
                        </fieldset>
                    </div>
                    <!-- FOOTER -->
                    <div slot="modal-footer">
                        <d-button
                            @click.prevent="closeModal"
                            :class="{ disabled: submitting_save_draft }"
                            theme="danger"
                            ><i class="material-icons">close</i>
                            Anuluj</d-button
                        >
                        <d-button
                            @click.prevent="saveDraftSubmit"
                            :class="{ isLoading: submitting_save_draft }"
                            theme="success"
                            class="ml-3"
                            ><i class="material-icons">check</i>
                            Potwierdź</d-button
                        >
                    </div>
                </ss-modal>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SsDate from '../components/common/SsDate';
import SsModal from '../components/common/SsModal';
import SsTextarea from '../components/common/SsTextarea';
import SsPriceInput from '../components/common/SsPriceInput';
import LarErrors from '../helpers/Errors';
import FileSaver from 'file-saver';
import lodash from 'lodash';
import FormUtils from '@/utils/FormUtils.js';
import CommonUtils from '@/utils/CommonUtils';
import { capitalParts } from '@/utils/scheduleCapitals';

export default {
  name: 'ScheduleNew',
  components: {
    SsDate,
    SsModal,
    SsTextarea,
    SsPriceInput,
    LarErrors,
    lodash,
  },
  data() {
    return {
      fetched: false,
      lar_errors: LarErrors,
      submitting: false,
      isLoadingPdf: false,
      isLoadingExcel: false,
      saveDraftModal: false,
      submitting_save_draft: false,
      isValuesSetup: false,
      vatIncluded: false,
      isCalculatingGross: false,
      isCalculatingNet: false,
      installment_frequency_periods: [
        { id: 5, name: '1 tydzień' },
        { id: 1, name: '2 tygodnie' },
        { id: 2, name: '1 miesiąc' },
        { id: 3, name: '2 miesiące' },
        { id: 4, name: '3 miesiące' },
      ],
      interests_loading: false,
      installment_rate_net: 0,
      schedule: {
        client_id: null, // id klienta
        installment_frequency: 2, // częstotliwość rat
        installment_sum: 0, // suma rat
        interest_sum: 0, // suma odsetek
        interest_penalty_sum: 0, // suma odsetek karnych
        loan_amount: 1000, // kwota pożyczki
        installment_rate: 100, // oprocentowanie raty
        interest_rate: 5, // oprocentowanie odsetek
        installment_fee: 100, // kwota raty
        number_of_installments: 12, // liczba rat
        first_installment_date: '', // data pierwszej raty
        loan_installment_sum: 0, // suma kwoty pożyczki plus raty
        loan_final_sum: 0, // kwota ostateczna,
        include_vat: 0,
        payment_allocation: 'capital_first',
        contract_date: '',
        comments: '',
        installments: [],
      },
    };
  },
  computed: {
    firstPaymentDate() {
      return new Date(this.schedule.first_installment_date);
    },
    ...mapGetters(['allClients', 'allClientsShort']),
    installmentsTrigger() {
      return `${this.schedule.interest_rate}=${this.schedule.installments
        .map(installment =>
          [
            installment.installment_fee,
            installment.payment_date,
            installment.capital,
          ].join('-'))
        .join(';')}`;
    },
  },
  methods: {
    ...mapActions(['getAllClients', 'getAllClientsShort']),
    async setGrossForValue(
      value,
      fieldPath,
      errorFieldName,
      callbackSource,
    ) {
      if (this.isValuesSetup && callbackSource === 'input') {
        return;
      }

      if (
        callbackSource === 'input' &&
                (this.isCalculatingNet || this.isCalculatingGross)
      ) {
        return;
      }

      this.isCalculatingGross = true;
      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        this.$nextTick(function () {
          this.isCalculatingGross = false;
        });
        return;
      }

      const { value: grossValue, isError } =
                await FormUtils.getGrossValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = [
            'Błąd obliczenia wartości',
          ];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          this.$nextTick(function () {
            this.isCalculatingGross = false;
          });
          return;
        }
        this.lar_errors.clear(errorFieldName);
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
      this.calculateCapitals();
      this.$nextTick(function () {
        this.isCalculatingGross = false;
      });
    },
    async setNetForValue(value, fieldPath, errorFieldName, callbackSource) {
      if (this.isValuesSetup && callbackSource === 'input') {
        return;
      }

      if (
        callbackSource === 'input' &&
                (this.isCalculatingNet || this.isCalculatingGross)
      ) {
        return;
      }

      this.isCalculatingNet = true;

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        this.$nextTick(function () {
          this.isCalculatingNet = false;
        });

        return;
      }

      const { value: grossValue, isError } = await FormUtils.getNetValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = [
            'Błąd obliczenia wartości',
          ];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          this.$nextTick(function () {
            this.isCalculatingNet = false;
          });
          return;
        }
        this.lar_errors.clear(errorFieldName);
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
      this.calculateCapitals();
      this.$nextTick(function () {
        this.isCalculatingNet = false;
      });
    },
    calculateSums() {
      this.schedule.installment_sum = this.schedule.installment_rate;
      this.schedule.loan_installment_sum =
                this.schedule.loan_amount + this.schedule.installment_sum;
      this.schedule.loan_final_sum =
                this.schedule.loan_installment_sum + this.schedule.interest_sum;
    },
    rowThemeDanger(inst) {
      return (
        inst.capital < 0 ||
                (inst.capital === 0 && inst.installment_fee === 0)
      );
    },
    toNumber(number) {
      return Vue.toNumber(number);
    },
    optimalInstallmentsNumber() {
      this.schedule.number_of_installments = Math.floor(this.schedule.loan_installment_sum /
                    this.schedule.installment_fee);
      this.rearrangeInstallments(this.schedule.number_of_installments);
      this.generateTable();
      this.calculateCapitals();
    },
    optimalInstallmentFee() {
      this.schedule.installment_fee = Math.floor(this.schedule.loan_installment_sum /
                    this.schedule.number_of_installments);
      this.$forceUpdate();
      this.calculateCapitals();
    },
    singleInstallmentChanged() {
      this.calculateCapitals();
    },
    getLimitFrom(index) {
      return index < 2
        ? this.schedule.first_installment_date
        : this.schedule.installments[index - 1].payment_date;
    },
    getLimitTo(index) {
      return index < this.schedule.installments.length - 1
        ? this.schedule.installments[index + 1].payment_date
        : '';
    },
    downloadPdf() {
      if (
        this.schedule.installments[
          this.schedule.installments.length - 1
        ].capital < 0
      ) {
        Vue.swal({
          type: 'warning',
          title: 'Kapitał rat nie może być ujemny.',
          showConfirmButton: true,
        });
      } else {
        this.isLoadingPdf = true;
        let file_name = `harmonogram_${Vue.getCurrentDate()}.pdf`;
        if (
          this.schedule.schedule_attachment_name != undefined &&
                    this.schedule.schedule_attachment_name.length > 0
        ) {
          file_name = `${this.schedule.schedule_attachment_name}.pdf`;
        }
        axios
          .post('api/schedules/generate-pdf', this.schedule, {
            responseType: 'blob',
          })
          .then((response) => {
            const blob = new File([response.data], file_name, {
              type: 'application/xlsx',
            });
            FileSaver.saveAs(blob);
            this.isLoadingPdf = false;
          })
          .catch((error) => {
            this.isLoadingPdf = false;
            console.log(error);
            LarErrors.record(error.response.data.errors);
          });
      }
    },
    downloadExcel() {
      this.submitForm();
    },
    fetchClientsOptions(search) {
      this.getAllClientsShort({ search }, {});
    },
    submitDraft() {
      this.saveDraftModal = true;
    },
    closeModal() {
      this.saveDraftModal = false;
    },
    submitForm() {
      if (
        this.schedule.installments[
          this.schedule.installments.length - 1
        ].capital < 0
      ) {
        Vue.swal({
          type: 'warning',
          title: 'Kapitał rat nie może być ujemny.',
          showConfirmButton: true,
        });
      } else {
        this.isLoadingExcel = true;
        let file_name = `harmonogram_${Vue.getCurrentDate()}.xlsx`;
        if (
          this.schedule.schedule_attachment_name != undefined &&
                    this.schedule.schedule_attachment_name.length > 0
        ) {
          file_name = `${this.schedule.schedule_attachment_name}.xlsx`;
        }
        axios
          .post('api/schedules/generate-excel', this.schedule, {
            responseType: 'blob',
          })
          .then((response) => {
            const blob = new File([response.data], file_name, {
              type: 'application/xlsx',
            });
            FileSaver.saveAs(blob);
            this.isLoadingExcel = false;
          })
          .catch((error) => {
            this.isLoadingExcel = false;
            console.log(error);
            LarErrors.record(error.response.data.errors);
          });
      }
    },
    nextWeekDate(i) {
      const nextWeek = new Date(
        this.firstPaymentDate.getFullYear(),
        this.firstPaymentDate.getMonth(),
        this.firstPaymentDate.getDate() + 7 * i,
      );
      return this.dateFormat(nextWeek);
    },
    nextMonthDate(i) {
      const nextWeek = new Date(
        this.firstPaymentDate.getFullYear(),
        this.firstPaymentDate.getMonth() + i,
        this.firstPaymentDate.getDate(),
      );
      return this.dateFormat(nextWeek);
    },
    nextDate(i) {
      switch (this.schedule.installment_frequency) {
        case 1:
          return this.nextWeekDate(i * 2);
          break;
        case 2:
          return this.nextMonthDate(i);
          break;
        case 3:
          return this.nextMonthDate(i * 2);
          break;
        case 4:
          return this.nextMonthDate(i * 3);
          break;
        case 5:
          return this.nextWeekDate(i);
          break;
      }
    },
    saveDraftSubmit() {
      if (
        this.schedule.installments[
          this.schedule.installments.length - 1
        ].capital < 0
      ) {
        Vue.swal({
          type: 'warning',
          title: 'Kapitał rat nie może być ujemny.',
          showConfirmButton: true,
        });
      } else {
        this.submitting = true;
        this.schedule.draft = 1;
        const clonedSchedule = JSON.parse(JSON.stringify(this.schedule));
        clonedSchedule.installments[
          this.schedule.installments.length - 1
        ].installment_fee =
                    clonedSchedule.installments[
                      this.schedule.installments.length - 1
                    ].capital;
        axios
          .post('api/schedules/save-schedule', clonedSchedule)
          .then((response) => {
            this.submitting = false;
            Vue.swal({
              type: 'success',
              title: 'Umowa została dodana.',
              showConfirmButton: true,
            }).then(() => {
              this.$router.push({
                name: 'contract-edit',
                params: {
                  client_id: this.schedule.client_id,
                  schedule_id: response.data.id,
                },
              });
            });
          })
          .catch((error) => {
            Vue.swal({
              type: 'error',
              title: error.response.data.message,
              html: Vue.transformErrorsToHtml(error.response.data.errors),
              showConfirmButton: true,
            });
            this.submitting = false;
            LarErrors.record(error.response.data.errors);
            this.$emit('update:save', false);
          });
      }
    },
    dateFormat(d) {
      const dy = d.getFullYear();
      const dm =
                d.getMonth() + 1 < 10
                  ? `0${d.getMonth() + 1}`
                  : d.getMonth() + 1;
      const dd = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();

      return `${dy}-${dm}-${dd}`;
    },
    calculateCapitals(value) {
      this.calculateSums();
      let sum = 0;
      let interests_sum = 0;
      const installments = this.schedule.installments;
      // interest_first: z raty schodzi na kapitał tylko część ponad odsetki okresu
      const parts = capitalParts(installments, this.schedule.payment_allocation);
      for (let i = 0; i < installments.length; i++) {
        if (!installments[i]) return false;
        installments[i].capital =
                    this.schedule.loan_installment_sum - sum;
        sum += parts[i];
        interests_sum += installments[i].interest;
      }
      this.calculateSums();
      this.$forceUpdate();
      this.calculateLastInstallment(interests_sum);
    },
    calculateLastInstallment(interest_sum) {
      let sum = 0;
      const installments = this.schedule.installments;
      for (let i = 0; i < installments.length; i++) {
        if (!installments[i]) return false;
        if (i < installments.length - 1) {
          sum += installments[i].installment_fee;
        }
      }
      this.schedule.interest_sum = interest_sum;
      installments[installments.length - 1].installment_fee =
                this.schedule.loan_installment_sum - sum + interest_sum;
      this.$forceUpdate();
    },
    generateTable() {
      this.schedule.installments = [];
      for (let i = 0; i < this.schedule.number_of_installments; i++) {
        this.schedule.installments.push({
          installment_fee: this.schedule.installment_fee,
          interest_penalty: 0,
          payment_date: this.nextDate(i),
        });
      }
      this.calculateCapitals();
      this.$forceUpdate();
    },
    generatePaymentDates() {
      for (let i = 0; i < this.schedule.number_of_installments; i++) {
        if (!this.schedule.installments[i]) return false;
        this.schedule.installments[i].payment_date = this.nextDate(i);
      }
    },
    rearrangeInstallments(event) {
      const to = event.target ? event.target.value : event;
      const from = parseInt(this.schedule.installments.length);
      if (to > from) {
        for (let i = from; i < to; i++) {
          this.schedule.installments.push({
            interest_penalty: 0,
            installment_fee: this.schedule.installment_fee,
            payment_date: '',
          });
        }
        this.$forceUpdate();
        this.generatePaymentDates();
        this.calculateCapitals();
      }
      if (from > to) {
        for (let i = 0; i < from - to; i++) {
          this.schedule.installments.pop();
        }
        this.$forceUpdate();
        this.calculateCapitals();
      }
    },
    getInterests: _.debounce(function () {
      this.interests_loading = true;

      const data = {
        installments: this.schedule.installments.map(installment => ({
          installment_fee: installment.installment_fee,
          payment_date: installment.payment_date,
          capital: installment.capital,
        })),
        contract_date: this.schedule.contract_date,
        interest_rate: this.schedule.interest_rate,
        include_vat: this.schedule.include_vat,
        payment_allocation: this.schedule.payment_allocation,
      };

      axios
        .post('api/calculation/get-interests', data)
        .then((response) => {
          for (
            let i = 0;
            i < response.data.installments.length;
            i++
          ) {
            this.schedule.installments[i].interest =
                            response.data.installments[i].interest;
          }

          this.interests_loading = false;
          this.calculateCapitals();
        })
        .catch((error) => {
          this.interests_loading = false;
          console.log(error);
          LarErrors.record(error.response.data.errors);
        });
    }, 500),
  },
  mounted() {
    this.schedule.first_installment_date = this.dateFormat(new Date());
    this.schedule.contract_date = this.dateFormat(new Date());
    this.vatIncluded = this.schedule.include_vat !== 0;
    this.getAllClientsShort({}, {});
    this.calculateSums();
    this.generateTable();
    this.fetched = true;

    setTimeout(() => {
      this.calculateCapitals();
    }, 100);
  },
  watch: {
    'schedule.interest_rate': function () {
      this.calculateCapitals();
    },
    'schedule.payment_allocation': function () {
      this.calculateCapitals();
      this.getInterests();
    },
    'schedule.contract_date': function (to) {
      const date = new Date(to);
      const nextMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
      );
      this.schedule.first_installment_date = this.dateFormat(nextMonth);
      this.getInterests();
    },
    'schedule.loan_amount': function () {
      this.optimalInstallmentFee();
    },
    'schedule.installment_frequency': function () {
      this.generatePaymentDates();
    },
    'schedule.first_installment_date': function () {
      this.generatePaymentDates();
    },
    installmentsTrigger() {
      this.getInterests();
    },
    async vatIncluded(newValue) {
      this.schedule.include_vat = newValue ? 1 : 0;

      if (!this.fetched) {
        return;
      }

      if (newValue) {
        Vue.set(this, 'isValuesSetup', true);

        Vue.set(
          this,
          'installment_rate_net',
          this.schedule.installment_rate,
        );
        await this.$nextTick();

        await this.setGrossForValue(
          this.installment_rate_net,
          'schedule.installment_rate',
          'installment_rate_net',
        );

        await this.$nextTick();
        Vue.set(this, 'isValuesSetup', false);
      } else {
        Vue.set(
          this.schedule,
          'installment_rate',
          this.installment_rate_net,
        );
      }

      this.getInterests();
      this.calculateCapitals();
    },
  },
};
</script>

<style>
.col-id {
    width: 100px;
}
tr.red {
    color: red;
}
.m-top {
    margin-top: 10px;
}
td.is-loading {
    opacity: 0.5;
}
</style>
